export default __webpack_public_path__ + "5fbd497c3177293e60aa510b2e20908b.coffee";